import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './plugins/router';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import { app } from './utils/firebase';
import xss from 'xss';
import VueCarousel from 'vue-carousel';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueCarousel);

// xss prevention
Vue.prototype.$sanitize = html => {
  return xss(html);
}

new Vue({
  store,
  vuetify,
  router,
  created() {
    // load edit info
    if (localStorage.isEdit !== null || localStorage.isEdit !== undefined) {
      store.state.isEdit = localStorage.isEdit === 'true';
    }
    // load auth info
    app.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        var email = user.email;
        console.log("signed in: ", email);
        store.state.isAuthenticated = true;
      } else {
        // User is signed out.
        store.state.isAuthenticated = false;
        store.state.isEdit = false;
      }
    });
  },
  render: h => h(App)
}).$mount('#app')
